import React from 'react'

export default function DashboardCars() {
  return (
    <div>
      Dashboard Cars
    </div>
  )
}
